// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSearchModal_container__Hea-w"};